/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Message Form Row
 */

import { Box, type BoxProps } from '@chakra-ui/react'
import React from 'react'

export const FormRow = ({ ...props }: Omit<BoxProps, 'as'>) => {
  return <Box<'div'> pb={2} {...props} className={props.className} />
}
